import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PlayerInfoStore {

}

export enum PlayerInfoStoreKeys {

}
